<template>
  <a href="#" aria-hidden="true" data-attribute="back-to-top" class="back-to-top">
    <svg class="icon icon-light">
      <use :xlink:href="icons.itArrowUp"></use>
    </svg>
  </a>
</template>

<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'modal-search',
  components: {
  },
  data() {
    return {
      icons: {
        itArrowUp: `${sprites}#it-arrow-up`,
      },
    };
  },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/BackToTopButton.vue